import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex relative" }
const _hoisted_2 = {
  key: 2,
  class: "absolute flex top-0 left-0 w-full h-full bg-brand-black z-50"
}
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col py-5 px-4 justify-center space-y-4 z-10"
}
const _hoisted_4 = { class: "flex flex-col space-y-2" }
const _hoisted_5 = { class: "flex flex-col space-y-2" }
const _hoisted_6 = {
  key: 0,
  class: "text-brand-light-gray text-sm pb-2"
}
const _hoisted_7 = { class: "flex flex-col space-y-2" }
const _hoisted_8 = {
  key: 1,
  class: "flex flex-col py-5 px-4 justify-center space-y-4 z-10"
}
const _hoisted_9 = { class: "flex flex-col space-y-2" }
const _hoisted_10 = { class: "flex grid gap-2 grid-cols-1" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "animate-spin h-7 w-7 text-white m-auto",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_13 = {
  key: 1,
  class: "m-auto w-8 fill-current text-white/75",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}
const _hoisted_14 = { class: "flex flex-col space-y-2" }
const _hoisted_15 = { class: "flex flex-col space-y-2" }
const _hoisted_16 = { class: "flex flex-col space-y-2" }
const _hoisted_17 = { class: "flex flex-col space-y-2" }
const _hoisted_18 = { class: "flex flex-col space-y-2" }
const _hoisted_19 = { class: "flex flex-col space-y-2" }
const _hoisted_20 = { class: "flex flex-col space-y-2" }
const _hoisted_21 = { class: "flex flex-col space-y-2" }
const _hoisted_22 = { class: "grid grid-cols-1 gap-2" }
const _hoisted_23 = { class: "flex flex-col space-y-2" }
const _hoisted_24 = { class: "flex flex-col space-y-2" }
const _hoisted_25 = {
  key: 2,
  class: "flex flex-col py-5 px-4 justify-center space-y-4 z-10"
}
const _hoisted_26 = { class: "flex flex-col space-y-2" }
const _hoisted_27 = { class: "flex flex-col space-y-2" }

import {
  alertController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonLabel,
  IonPage,
  IonSegment,
  IonSegmentButton,
  IonToolbar,
  modalController,
  toastController,
} from '@ionic/vue';
import {computed, onMounted, PropType, reactive, Ref, ref} from 'vue';
import InputCheckbox from "@/components/InputCheckbox.vue";
import useCamera from "@/composables/useCamera";
import {CameraResultType, CameraSource} from "@capacitor/camera";
import ApiService from "@/services/api/apiService";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {EventPrivacy} from "@/definitions/EventPrivacy";
import InputField from "@/components/InputField.vue";
import {EventType} from "@/definitions/EventType";
import {DateTime} from "luxon";
import MenuButton from "@/components/MenuButton.vue";
import InputTextarea from "@/components/InputTextarea.vue";
import ChooseLocationPage from "@/views/common/ChooseLocationPage.vue";
import {EventInterface} from "@/interfaces/EventInterface";



export default /*@__PURE__*/_defineComponent({
  __name: 'EventCRUDPage',
  props: {
  event: {
    type: Object as PropType<EventInterface>,
    required: false
  }
},
  setup(__props) {

const loading = ref(true)
const busy = ref(false)
const posting = ref(false)

const errors = ref({})

const props = __props

const privacyOptions = ref([
  {
    text: 'Public',
    description: 'Visible to everyone',
    value: EventPrivacy.Public
  },
  {
    text: 'Invite-only',
    description: 'Users must request to attend this event',
    value: EventPrivacy.InviteOnly
  },
])

const guestListPrivacyOptions = ref([
  {
    text: 'Public',
    description: 'Guest list visible to everyone',
    value: true
  },
  {
    text: 'Private',
    description: 'Guest list only visible to event organiser',
    value: false
  },
])


const typeOptions = ref([
  {
    text: 'Club',
    // description: 'Visible to everyone',
    value: EventType.Club
  },
  {
    text: 'House Party',
    // description: 'Users must request to attend this event',
    value: EventType.HouseParty
  },
  {
    text: 'Hotel',
    // description: 'Users must request to attend this event',
    value: EventType.Hotel
  },

  {
    text: 'Outdoors',
    // description: 'Users must request to attend this event',
    value: EventType.Outdoors
  },
])

const eventPhotos: Ref<string[]> = ref([])
const form: any = reactive({
  id: '',
  name: '',
  starts_at: DateTime.now().startOf('hour').plus({hour: 1}).toFormat('yyyy-MM-dd HH:mm'),
  ends_at: DateTime.now().startOf('hour').plus({hour: 1}).toFormat('yyyy-MM-dd HH:mm'),
  capacity: 0,
  type: [],
  visibility: [EventPrivacy.Public],
  public_guest_list: [true],
  description: '',
  rules: '',
  location: '',
  lat: '',
  lng: ''
})

onMounted(async () => {

  if (props.event) {
    form.id = props.event.id
    form.name = props.event.name
    form.starts_at = DateTime.fromISO(props.event.starts_at).toFormat(`yyyy-MM-dd'T'HH:mm`)
    form.ends_at = DateTime.fromISO(props.event.ends_at).toFormat(`yyyy-MM-dd'T'HH:mm`)
    form.capacity = props.event.capacity
    form.type = [props.event.type]
    form.visibility = [props.event.visibility]
    form.public_guest_list = [Boolean(props.event.public_guest_list)]
    form.description = props.event.description
    form.rules = props.event.rules
    form.location = props.event.location
    form.lat = props.event.lat
    form.lng = props.event.lng

    if (props.event.photo_url) eventPhotos.value.push(props.event.photo_url)

  }

  loading.value = false
})


const goBack = async () => {

  if (busy.value || posting.value) return

  const modal = await alertController.create({
    header: 'Discard',
    message: `Are you sure you want to discard any changes?`,
    buttons: [
      {
        text: 'Yes',
        role: 'destructive',
        handler: () => {
          modalController.dismiss()
        }
      },
      {
        text: 'No',
      },

    ]
  })

  await modal.present()

}

const canPost = computed(() => {
  return true
})

const createEvent = async () => {

  const event: any = Object.assign({}, form)

  event.visibility = event.visibility[0]
  event.type = event.type[0]
  event.public_guest_list = event.public_guest_list[0]

  Object.keys(event).forEach((key: any) => {
    if (!event[`${key}`] && !['capacity', 'public_guest_list'].includes(key) ) delete event[`${key}`]
  })

  event.starts_at = DateTime.fromFormat(event.starts_at, `yyyy-MM-dd'T'HH:mm`).toUTC().toISO()
  event.ends_at = DateTime.fromFormat(event.ends_at, `yyyy-MM-dd'T'HH:mm`).toUTC().toISO()

  if (posting.value) return
  posting.value = true
  try {
    errors.value = {}
    const newRecord = await ApiService.Events().create(event)
    if (eventPhotos.value.length) await ApiService.Events().imageFor(newRecord.id, eventPhotos.value[0])
    posting.value = false
    await modalController.dismiss()
    await Observable.emit(ObservableEvent.EventsChanged)
    await Observable.emit(ObservableEvent.PullToRefreshMyEvents)
  } catch (e: any) {
    posting.value = false
    if (e.data.errors) errors.value = e.data.errors
    const toast = await toastController.create({
      message: e.data.message,
      duration: 3000,
      position: 'bottom',
      color: 'danger'
    });
    await toast.present();
  }

}

const updateEvent = async () => {

  const event: any = Object.assign({}, form)

  event.visibility = event.visibility[0]
  event.type = event.type[0]
  event.public_guest_list = event.public_guest_list[0]

  Object.keys(event).forEach((key: any) => {
    if (!event[`${key}`] && !['capacity', 'public_guest_list'].includes(key) ) delete event[`${key}`]
  })

  event.starts_at = DateTime.fromFormat(event.starts_at, `yyyy-MM-dd'T'HH:mm`).toUTC().toISO()
  event.ends_at = DateTime.fromFormat(event.ends_at, `yyyy-MM-dd'T'HH:mm`).toUTC().toISO()


  if (posting.value) return
  posting.value = true
  try {
    errors.value = {}
    const newRecord = await ApiService.Events().update(event)
    if (eventPhotos.value.length && !eventPhotos.value[0].includes('https')) await ApiService.Events().imageFor(newRecord.id, eventPhotos.value[0])
    if (!eventPhotos.value.length) await ApiService.Events().deleteImageFor(newRecord.id)
    posting.value = false
    await modalController.dismiss()
    await Observable.emit(ObservableEvent.EventsChanged)
    await Observable.emit(ObservableEvent.PullToRefreshMyEvents)
  } catch (e:any) {
    posting.value = false
    if (e.data.errors) errors.value = e.data.errors
    const toast = await toastController.create({
      message: e.data.message,
      duration: 3000,
      position: 'bottom',
      color: 'danger'
    });
    await toast.present();
  }

}


const tab = ref('details')
const tabChanged = async (event: any) => {
  tab.value = event.detail.value
}


const addPhoto = async () => {

  if (busy.value || posting.value) return

  try {
    const photo = await useCamera(CameraSource.Photos, CameraResultType.Base64)
    busy.value = true
    if (Object.prototype.hasOwnProperty.call(photo, 'base64String')) eventPhotos.value.push(`data:image/${photo.format};base64,${photo.base64String}`)
    busy.value = false
  } catch (e) {
    busy.value = false
  }

}

const removePhoto = async (index: number) => {

  if (busy.value || posting.value) return

  const modal = await alertController.create({
    header: 'Remove Photo',
    message: 'Are you sure you want to remove this photo from the post?',
    buttons: [
      {
        text: 'Yes',
        role: 'destructive',
        handler: async () => {
          eventPhotos.value.splice(index, 1)
        }
      },
      {
        text: 'No',
      },

    ]
  })

  await modal.present()

}

const chooseLocation = async () => {

  const modal = await modalController.create({
    component: ChooseLocationPage,
    componentProps: {},
    mode: 'ios',
    presentingElement: await modalController.getTop(),
  })
  await modal.present()

  const location: any = (await modal.onWillDismiss()).data
  if (location) {
    form.location = location.name
    form.lat = location.lat
    form.lng = location.lng
  }

}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), { class: "!p-0 !m-0" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { class: "justify-between flex w-full" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: goBack,
                    class: "bg-brand-dark-gray rounded-md"
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("svg", {
                        class: "fill-current text-white w-6 h-6 p-0.5",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 320 512"
                      }, [
                        _createElementVNode("path", { d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" })
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_1, [
                    (!__props.event)
                      ? (_openBlock(), _createBlock(_unref(IonButton), {
                          key: 0,
                          onClick: createEvent,
                          class: "!text-xl"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass({
                  'text-brand-light-gray' : !canPost.value,
                  'text-brand-lime' : canPost.value
                })
                            }, "Create ", 2)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (__props.event)
                      ? (_openBlock(), _createBlock(_unref(IonButton), {
                          key: 1,
                          onClick: updateEvent,
                          class: "!text-xl"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass({
                  'text-brand-light-gray' : !canPost.value,
                  'text-brand-lime' : canPost.value
                })
                            }, "Update ", 2)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (posting.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[11] || (_cache[11] = [
                          _createElementVNode("svg", {
                            class: "animate-spin m-auto h-5 w-5 text-brand-lime",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            })
                          ], -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonSegment), {
            onIonChange: tabChanged,
            value: tab.value,
            class: "relative z-50 backdrop-blur-2xl bg-brand-black ml-0 w-full sticky top-0",
            "swipe-gesture": false,
            mode: "ios"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonSegmentButton), { value: "details" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), { class: "text-lg font-medium" }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createTextVNode(" Details ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonSegmentButton), { value: "guest-list" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), { class: "text-lg font-medium" }, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createTextVNode(" Guest List ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              false
                ? (_openBlock(), _createBlock(_unref(IonSegmentButton), {
                    key: 0,
                    value: "settings"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { class: "text-lg font-medium" }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode(" Settings ", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["value"]),
          (!loading.value && tab.value === 'guest-list')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "font-medium text-xl text-white" }, "Capacity", -1)),
                  _createVNode(InputField, {
                    error: errors.value && errors.value['capacity'] ? errors.value['capacity'][0] : undefined,
                    modelValue: form.capacity,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.capacity) = $event)),
                    type: "number",
                    inputmode: "numeric",
                    enterkeyhint: "next",
                    placeholder: ""
                  }, null, 8, ["error", "modelValue"]),
                  _cache[16] || (_cache[16] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "text-brand-light-gray text-xxs -mt-1" }, "Enter 0 for no capacity limit on this event.")
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "font-medium text-xl text-white" }, "Privacy", -1)),
                  (form.public_guest_list[0] && form.visibility[0] === _unref(EventPrivacy).InviteOnly && false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Invite-only events with a public guest list will only be visible to guests who've been accepted and attending the event."))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(guestListPrivacyOptions.value, (p, pIndex) => {
                      return (_openBlock(), _createBlock(InputCheckbox, {
                        key: pIndex,
                        name: "privacy",
                        "return-single-value": true,
                        option: p,
                        modelValue: form.public_guest_list,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.public_guest_list) = $event))
                      }, null, 8, ["option", "modelValue"]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!loading.value && tab.value === 'details')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "font-medium text-xl text-white" }, "Image", -1)),
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eventPhotos.value, (photo, pIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: pIndex,
                        style: _normalizeStyle({
                'background-image' : `url('${photo}')`
              }),
                        class: "w-full h-60 bg-brand-dark-gray bg-cover bg-center rounded-md flex p-2"
                      }, [
                        (_openBlock(), _createElementBlock("svg", {
                          onClick: ($event: any) => (removePhoto(pIndex)),
                          class: "mt-auto ml-auto",
                          width: "25",
                          height: "25",
                          viewBox: "0 0 25 25",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [...(_cache[18] || (_cache[18] = [
                          _createElementVNode("rect", {
                            width: "25",
                            height: "25",
                            rx: "12.5",
                            fill: "white"
                          }, null, -1),
                          _createElementVNode("path", {
                            d: "M16.8921 7L12.5 11.3921L8.10786 7L7 8.10786L11.3921 12.5L7 16.8921L8.10786 18L12.5 13.6079L16.8921 18L18 16.8921L13.6079 12.5L18 8.10786L16.8921 7Z",
                            fill: "black"
                          }, null, -1)
                        ]))], 8, _hoisted_11))
                      ], 4))
                    }), 128)),
                    (!eventPhotos.value.length)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          onClick: addPhoto,
                          class: "w-full h-60 bg-brand-dark-gray rounded-md flex"
                        }, [
                          (busy.value)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[19] || (_cache[19] = [
                                _createElementVNode("circle", {
                                  class: "opacity-25",
                                  cx: "12",
                                  cy: "12",
                                  r: "10",
                                  stroke: "currentColor",
                                  "stroke-width": "4"
                                }, null, -1),
                                _createElementVNode("path", {
                                  class: "opacity-75",
                                  fill: "currentColor",
                                  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                }, null, -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          (!busy.value)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_13, [...(_cache[20] || (_cache[20] = [
                                _createElementVNode("path", { d: "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z" }, null, -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "font-medium text-xl text-white" }, "Name", -1)),
                  _createVNode(InputField, {
                    class: "relative z-0",
                    error: errors.value && errors.value['name'] ? errors.value['name'][0] : undefined,
                    modelValue: form.name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.name) = $event)),
                    type: "text",
                    enterkeyhint: "next",
                    placeholder: ""
                  }, null, 8, ["error", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "font-medium text-xl text-white" }, "Start date & time", -1)),
                  _createVNode(InputField, {
                    class: "relative z-0",
                    error: errors.value && errors.value['starts_at'] ? errors.value['starts_at'][0] : undefined,
                    modelValue: form.starts_at,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.starts_at) = $event)),
                    type: "datetime-local",
                    enterkeyhint: "next",
                    placeholder: ""
                  }, null, 8, ["error", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "font-medium text-xl text-white" }, "End date & time", -1)),
                  _createVNode(InputField, {
                    class: "relative z-0",
                    error: errors.value && errors.value['ends_at'] ? errors.value['ends_at'][0] : undefined,
                    modelValue: form.ends_at,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.ends_at) = $event)),
                    type: "datetime-local",
                    enterkeyhint: "next",
                    placeholder: ""
                  }, null, 8, ["error", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _cache[25] || (_cache[25] = _createElementVNode("div", { class: "font-medium text-xl text-white" }, "Description", -1)),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(InputTextarea, {
                      modelValue: form.description,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.description) = $event)),
                      placeholder: "",
                      enterkeyhint: "next",
                      counter: false,
                      error: errors.value && errors.value.hasOwnProperty('description') ? errors.value['description'][0] : null
                    }, null, 8, ["modelValue", "error"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "font-medium text-xl text-white" }, "Rules", -1)),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(InputTextarea, {
                      modelValue: form.rules,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.rules) = $event)),
                      placeholder: "",
                      enterkeyhint: "next",
                      counter: false,
                      error: errors.value && errors.value.hasOwnProperty('rules') ? errors.value['rules'][0] : null
                    }, null, 8, ["modelValue", "error"])
                  ])
                ]),
                _createElementVNode("div", {
                  onClick: chooseLocation,
                  class: "flex flex-col space-y-1"
                }, [
                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "text-white font-medium text-lg" }, "Location", -1)),
                  _createVNode(MenuButton, {
                    class: "text-left",
                    name: form.location ? form.location : 'Add location'
                  }, null, 8, ["name"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[28] || (_cache[28] = _createElementVNode("div", { class: "font-medium text-xl text-white" }, "Type", -1)),
                  _createElementVNode("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeOptions.value, (p, pIndex) => {
                      return (_openBlock(), _createBlock(InputCheckbox, {
                        key: pIndex,
                        name: "type",
                        "return-single-value": true,
                        modelValue: form.type,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.type) = $event)),
                        option: p
                      }, null, 8, ["modelValue", "option"]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _cache[29] || (_cache[29] = _createElementVNode("div", { class: "font-medium text-xl text-white" }, "Privacy", -1)),
                  _createElementVNode("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(privacyOptions.value, (p, pIndex) => {
                      return (_openBlock(), _createBlock(InputCheckbox, {
                        key: pIndex,
                        name: "privacy",
                        "return-single-value": true,
                        modelValue: form.visibility,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.visibility) = $event)),
                        option: p
                      }, null, 8, ["modelValue", "option"]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!loading.value && tab.value === 'settings')
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _cache[30] || (_cache[30] = _createElementVNode("div", { class: "font-medium text-xl text-white" }, "Privacy", -1)),
                  _createElementVNode("div", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(privacyOptions.value, (p, pIndex) => {
                      return (_openBlock(), _createBlock(InputCheckbox, {
                        key: pIndex,
                        name: "privacy",
                        "return-single-value": true,
                        modelValue: form.visibility,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.visibility) = $event)),
                        option: p
                      }, null, 8, ["modelValue", "option"]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "safe-area-bottom" }, null, -1))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})